import { render, staticRenderFns } from "./FiniquitoDetail.vue?vue&type=template&id=624f2428&lang=pug&"
import script from "./FiniquitoDetail.vue?vue&type=script&lang=js&"
export * from "./FiniquitoDetail.vue?vue&type=script&lang=js&"
import style0 from "./FiniquitoDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FiniquitoDetail.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VDataTable,
  VFlex,
  VLayout,
})
